import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SSNMaskerDirective } from '../../helper/ssn-mask.directive';
import { PhoneFormatDirective } from '../../helper/phone-format.directive';
import { MaskerDirective } from '../../helper/mask.directive';
@Component({
  selector: 'app-textinput',
  standalone: true,
  imports: [InputTextModule, CommonModule, FormsModule, SSNMaskerDirective, PhoneFormatDirective, MaskerDirective],
  templateUrl: './textinput.component.html',
  styleUrls: ['./textinput.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextinputComponent),
      multi: true
    }
  ]
})

export class TextinputComponent implements ControlValueAccessor {
  @Input() disabled: boolean = false;
  @Input() id: any;
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() label: string = '';
  @Input() inputlabel: string = '';
  @Input() customClass: string = '';
  @Input() isrequired: boolean = false;
  @Input() maxlength: any;
  @Input() value: string = '';
  @Input() applySsnMasker: boolean = false;
  @Input() appPhoneFormat: boolean = false;
  @Input() maskFormat: boolean = false;
  touched: boolean = false;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

    onValueChange(value: string) {
      this.value = value;
      this.touched = true; 
      this.valueChange.emit(value); 
      this.onChange(value);
      this.onTouched();
    }
  
  // Keep track of the current value of the input field
  private _value: string = '';
  dynamicPlaceholder: any;

  // Write value to the component (called by ngModel)
  writeValue(value: string): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  // Register the onChange function (called when the value changes)
  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Set disabled state for the input field
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // The function that gets called when the input is blurred (touched)
  onBlur(): void {
    this.onTouched();
  }

  // Internal callback functions
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};
}
